import * as moment from 'moment';
const patternSearch = /[.|,]+/g;

export const cleanCharacters = value => value.replace(patternSearch, '');

export const calculateDVDNI = num => {
  let m = 0;
  let s = 1;
  let digits = parseInt(num, 10);
  for (; digits; digits = Math.floor(digits / 10)) {
    // eslint-disable-next-line no-plusplus, no-mixed-operators
    s = (s + (digits % 10) * (9 - (m++ % 6))) % 11;
  }
  return s ? (s - 1).toString() : 'K';
};
export const getNumber = value => {
  const [intNumber, decimal] = value.split('.');
  const num = intNumber.slice(0, intNumber.length);
  const extraDigits = (3 - (num.length % 3)) % 3;
  let numCompleted = `${Array(extraDigits)
    .fill('0')
    .join('')}${num}`;
  numCompleted = numCompleted.match(/.{1,3}/g).join('.');
  let finalValue = numCompleted.slice(extraDigits, numCompleted.length);
  finalValue = decimal && decimal.length > 0 ? `${finalValue},${decimal}` : finalValue;
  return finalValue;
};

export const rutFormat = value => {
  const [number, dv] = value.split('-');
  return `${getNumber(number)}-${dv}`;
};

export const getFormatRut = value => {
  const len = value.toString().length;
  const num = value.slice(0, len - 1);
  const dv = value.slice(len - 1, len);
  return `${getNumber(num)}-${dv}`;
};

export const dateFormat = formatter => value => moment(value).format(formatter);

export const dateFormatUTC = formatter => value => moment(value).format(formatter);

export const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};
